import { Observable, ReplaySubject, tap } from "rxjs";

import { api } from "./api";
import { errorHandlerService } from "./errorHandler";

class AudioService {
  private audioInfo$ = new ReplaySubject<string>(1);

  getAudioUrl(playlistURL: string): Observable<string> {
    return api.get<string>(playlistURL).pipe(
      tap({
        next: (data) => this.audioInfo$.next(data),
        error: (err) =>
          errorHandlerService.defineCurrentError({
            type: "api",
            data: errorHandlerService.getErrorDescriptionByErrorCode(
              err.response.status
            ),
          }),
      })
    );
  }
}

export const audioService = new AudioService();
